import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { ChevronLeft } from "lucide-react";
import SporterRoosterSection from "./SporterRoosterSection";
import BottomNav from "../../components/ui/BottomNav";

export default function RoosterPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const heeftRooster = user?.company_id || user?.persoonlijk_rooster_enabled;

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <div className="max-w-2xl mx-auto px-4 pt-5 pb-28">
        <button onClick={() => navigate("/account")}
          className="flex items-center gap-2 text-zinc-500 hover:text-white text-sm font-semibold mb-6 transition-colors">
          <ChevronLeft size={16} /> Profiel
        </button>
        <h1 className="text-white font-black text-2xl mb-6">Rooster</h1>

        {heeftRooster ? (
          <SporterRoosterSection user={user} />
        ) : (
          <div className="bg-[#111] border border-white/8 rounded-2xl p-10 text-center">
            <p className="text-zinc-400 font-semibold mb-2">Rooster niet beschikbaar</p>
            <p className="text-zinc-600 text-sm">Je hebt nog geen toegang tot een groepsrooster. Neem contact op met je trainer.</p>
          </div>
        )}
      </div>
      <BottomNav />
    </div>
  );
}
